import React, { useState } from "react";
import styles from "./delegate-creation-card.module.scss";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import { useAccount } from "wagmi";
import useDelegateCreation from "@/features/mod-perms/hooks/useDelegateCreation.hook";
import classNames from "classnames";
import { AnimatePresence } from "framer-motion";
import InputSwitch from "@/features/mod-perms/components/cards/creation-card/input-switch";
import { CreationInputField } from "@/features/mod-perms/components/cards/creation-card/creation-input-field";
import ModularCloseBtn from "@/features/mod-perms/components/close-btn/close-btn";

interface Props {
  isLoading: boolean;
}

const DelegateCreationCard = ({ isLoading }: Props) => {
  const account = useAccount();
  const [isClosing, setIsClosing] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    cancelDelegateCreation,
    isDelegateBeingCreated,
    isDelegateContextGranted,
    delegatePermissions,
  } = useModularPermissionsStore();

  const {
    walletAddress,
    walletAddressError,
    createDelegate,
    socialPlatform,
    setSocialPlatform,
    userHandle,
    setUserHandle,
    handleWalletInputChange,
    handleInputStateToggle,
    inputState,
    setInputState,
    reset,
    isLoadingSocialAccount,
    setIsLoadingSocialAccount,
  } = useDelegateCreation();

  function handleClose() {
    if (delegatePermissions.length) {
      setIsClosing(true);
      setTimeout(() => {
        cancelDelegateCreation();
        setIsClosing(false);
        reset();
      }, 20);
    } else {
      cancelDelegateCreation();
      reset();
    }
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await createDelegate();
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (
    !isLoading &&
    account.isConnected &&
    isDelegateBeingCreated &&
    isDelegateContextGranted()
  )
    return (
      <div
        className={classNames(
          styles.creationCardContainer,
          delegatePermissions.length && styles.animated,
        )}
      >
        <div className={styles.creationCard}>
          <div className={styles.inputContainer}>
            {/* <p>Create delegate wallet address:</p> */}
            <InputSwitch
              inputSwitchState={inputState}
              setInputSwitchState={handleInputStateToggle}
            />
            <div className={styles.input}>
              {walletAddressError && (
                <p className={styles.error}>{walletAddressError}</p>
              )}

              <AnimatePresence>
                <CreationInputField
                  activeInputType={inputState}
                  selectedPlatform={socialPlatform}
                  setSelectedPlatform={setSocialPlatform}
                  userHandle={userHandle}
                  setUserHandle={setUserHandle}
                  setWalletAddress={handleWalletInputChange}
                  walletAddress={walletAddress}
                  createDelegate={handleSubmit}
                  isLoading={isSubmitting}
                />
              </AnimatePresence>
            </div>
            <div className={styles.closeBtn}>
              <ModularCloseBtn
                aria-label="Remove"
                onClick={handleClose}
                color="light"
              />
            </div>
            {/* <div className={styles.buttons}>
              <button className={styles.cancelBtn} onClick={handleClose}>
                Cancel
              </button>
            </div> */}
          </div>
        </div>
      </div>
    );
};

export default DelegateCreationCard;
